import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=be53ffac&scoped=true&"
import script from "./CalendarWidget.vue?vue&type=script&lang=js&"
export * from "./CalendarWidget.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWidget.vue?vue&type=style&index=0&id=be53ffac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be53ffac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be53ffac')) {
      api.createRecord('be53ffac', component.options)
    } else {
      api.reload('be53ffac', component.options)
    }
    module.hot.accept("./CalendarWidget.vue?vue&type=template&id=be53ffac&scoped=true&", function () {
      api.rerender('be53ffac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/CalendarWidget.vue"
export default component.exports